import { createContext, useContext, useEffect, useState } from "react";
import SockJS from "sockjs-client";
import Stomp, { over } from "stompjs";

interface WebSocketContextType {
  stompClient: Stomp.Client | null;
}

const WebSocketContext = createContext<WebSocketContextType | undefined>(
  undefined
);

/**
 *
 * @returns
 */
export const useWebSocket = (): WebSocketContextType => {
  const context = useContext(WebSocketContext);
  if (context === undefined) {
    throw new Error("useWebSocket must be used within a WebSocketProvider");
  }
  return context;
};

export const WebSocketProvider = (props: any) => {
  const [stompClient, setStompClient] = useState<Stomp.Client | null>(null);

  useEffect(() => {
    const MAX_RETRIES = 3;
    let retryDelay = 1000;
    let retryCount = 0;
    let timeoutId: ReturnType<typeof setTimeout>;
    let active = true;

    const connect = () => {
      //const socket = new SockJS(`https://register.erp.xauto.ro/organization-service/wss`);
      const socket = new SockJS("/organization-service/wss");
      //const socket = new SockJS(`http://localhost:8080/ws`);
      const client: any = over(socket);
      client.debug = null;
      client.connect(
        {
          //Authorization: `Bearer ${token}`
        },
        () => {
          retryDelay = 1000;
          retryCount = 0;
          setStompClient(client);
        },
        (error: any) => {
          console.error("WebSocket connection error: ", error);
          setStompClient(null);
          if (active && retryCount < MAX_RETRIES) {
            retryCount++;
            console.warn(`WebSocket reconnect attempt ${retryCount}/${MAX_RETRIES}`);
            timeoutId = setTimeout(() => {
              retryDelay = Math.min(retryDelay * 2, 30000);
              connect();
            }, retryDelay);
          } else if (retryCount >= MAX_RETRIES) {
            console.error("WebSocket max reconnect attempts reached. Giving up.");
          }
        }
      );
    };

    connect();

    return () => {
      active = false;
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <WebSocketContext.Provider value={{ stompClient }}>
      {props.children}
    </WebSocketContext.Provider>
  );
};
